(function () {
    'use strict';

    angular
        .module('portalApp')
        .directive('scenarioChart', scenarioChart);

    scenarioChart.$inject = ['$window', 'chartConfig', 'TimeseriesUtils', 'DateUtils', 'OgrChart'];
    function scenarioChart($window, chartConfig, TimeseriesUtils, DateUtils, OgrChart) {
        // Generates chart for one or more timeseries
        // Usage:
        //  <div data-scenario-chart chart-data="vm.chartData">
        //  <div data-scenario-chart chart-data="vm.chartData" line-style="vm.lineStyle">
        //  <div data-scenario-chart chart-data="vm.chartData" date-format="vm.dateFormat" date-frequency="vm.dateFreq">
        //  <div data-scenario-chart chart-data="vm.chartData" shadow-range="vm.shadowRange">
        //  <div data-scenario-chart chart-data="vm.chartData" min-date="vm.minimumDate">
        //  <div data-scenario-chart chart-data="vm.chartData" max-date="vm.maximumDate">
        // Input structure:
        //  vm.chartData = {
        //      chartId: "someId",
        //      title: "some title",
        //      lineSeries: [
        //          [
        //              {date: Date, value: Double},
        //              ...
        //          ],
        //          ...
        //      ]
        //  }
        //  vm.lineStyle = [
        //      {
        //          width: 2,
        //          color: '#3734FF',
        //          dashSetting: [<dashWidth>,<emptySpaceWidth>],
        //          markerSize: 2 (0: no markers)
        //      },
        //      ...
        //  ]
        //  vm.shadowRange = [
        //      {
        //          start: Date,
        //          end: Date,
        //          color: '#373737',
        //          opacity: 0.5
        //      },
        //      ...
        //  ]
        // Creates:
        //  <div data-dd-scenario-chart class="scenarioChart">
        var directive = {
            link: linkFunc,
            restrict: 'A',
            scope: {
                chartData: '<',
                lineStyle: '<',
                dateFormat: '<',
                dateFrequency: '<',
                shadowRange: '<',
                minDate: '<',
                maxDate: '<',
                yLabel: '<'
            }
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.addClass('scenarioChart');
            element.attr('id', scope.chartData.chartId);

            makeChart();

            scope.$watch('chartData', updateChart, true);
            scope.$watch('lineStyle', updateChart, true);
            scope.$watch('dateFormat', updateChart, true);
            scope.$watch('dateFrequency', updateChart, true);
            scope.$watch('shadowRange', updateChart, true);
            scope.$watch('minDate', updateChart, true);
            scope.$watch('maxDate', updateChart, true);
            scope.$watch('yLabel', updateChart, true);
            //some responsiveness here: when window was resized - recalculate
            // height of the chart based on the parent height
            var win = angular.element($window);
            win.bind("resize", updateChart);
            element.on('$destroy', function () {
                win.unbind("resize", updateChart);
            });

            function updateChart() {
                //unbind this function before removing the chart
                win.unbind("resize", updateChart);
                OgrChart.destroy(element);
                element.empty();
                makeChart();
                win.bind("resize", updateChart);
            }

            function makeChart() {
                // console.log('here!');
                //load defaults
                var chartObject = angular.copy(chartConfig.scenarioChartDefaults.chartObject);
                var defaultLineStyles = angular.copy(chartConfig.scenarioChartDefaults.lineStyles);
                var defaultDateFormat = angular.copy(chartConfig.scenarioChartDefaults.dateFormat);
                var defaultFrequency = angular.copy(chartConfig.scenarioChartDefaults.frequency);
                var defaultShadowStyle = angular.copy(chartConfig.scenarioChartDefaults.shadowStyle);

                //get chart title from chartData
                chartObject.title.text = angular.copy(scope.chartData.title);

                //get the label for Y-axis
                var yLabel = angular.copy(scope.yLabel);
                if (!yLabel)
                    yLabel = "";

                //get lines' series from chartData
                var lineData = angular.copy(scope.chartData.lineSeries);

                //try getting lines' styles from lineStyle
                var lineStyles = angular.copy(scope.lineStyle);

                //try getting tick labels' date format from dateFormat
                var dateFormat = angular.copy(scope.dateFormat);
                if (!dateFormat)
                    dateFormat = defaultDateFormat;

                //try getting tick labels' date frequency from dateFrequency
                var dateFrequency = angular.copy(scope.dateFrequency);
                if (!dateFrequency)
                    dateFrequency = defaultFrequency;

                //try getting shadow range from shadowRange
                var shadowRange = angular.copy(scope.shadowRange);
                if (!shadowRange)
                    shadowRange = [];

                //try getting minimum date from minDate
                var minDate = angular.copy(scope.minDate);

                //try getting maximum date from maxDate
                var maxDate = angular.copy(scope.maxDate);

                //update chart height based on the height of the parent element
                // console.log(element.parent().height());
                chartObject.height = element.parent().height() - 50;

                //if there was an error don't try to build a chart
                if (lineData === null) {
                    element.append('<p>Unable to plot the chart</p>');
                    return;
                }

                //if there's no line styles provided fill them in with the default line styles
                var ix;
                if (lineData.length > 0 && (!lineStyles || lineStyles.length == 0)) {
                    lineStyles = [];
                    for (ix = 0; ix < Math.min(6, lineData.length); ix++) {
                        lineStyles.push(defaultLineStyles.predefined[ix]);
                    }
                }

                //if line data is empty show the "Empty" message over an empty grid
                if (lineData.length == 0) {
                    chartObject.placeholder.show = true;
                    chartObject.xAxis.show = false;
                    chartObject.yAxis.show = false;
                    chartObject.yAxis.title.show = false;
                    chartObject.series = [];
                    chartObject.xAxis.shading = [];
                }
                else {
                    chartObject.placeholder.show = false;
                    chartObject.xAxis.show = true;
                    chartObject.yAxis.show = true;
                    chartObject.yAxis.title.show = true;
                    chartObject.yAxis.title.text = yLabel;
                    chartObject.series = [];
                    chartObject.xAxis.shading = [];
                }
                //cut the range of all chart series
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        if (minDate)
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint))
                                    return false;
                                return new Date(dataPoint.date) >= minDate;
                            });
                        if (maxDate)
                            lineData[ix] = lineData[ix].filter(function (dataPoint) {
                                if (angular.isUndefined(dataPoint))
                                    return false;
                                return new Date(dataPoint.date) <= maxDate;
                            });
                    }
                }
                //configure shadow ranges
                if (lineData.length > 0)
                    for (ix = 0; ix < shadowRange.length; ix++) {
                        var ixc = angular.copy(ix);
                        var sr = angular.copy(shadowRange[ixc]);
                        sr.visible = true;
                        //todo: lineData[0] is a nasty assumption -- use the series which starts the earliest instead
                        if (shadowRange[ixc].start) {
                            var convertedDate = DateUtils.convertLocalDateToServer(
                                TimeseriesUtils.parseTsDate(
                                    TimeseriesUtils.convertDateToTsDate(shadowRange[ixc].start, dateFrequency, dateFormat), dateFrequency
                                )
                            );
                            sr.start = lineData[0].findIndex(function (d) {
                                return d.date == convertedDate;
                            });
                        }
                        else {
                            sr.start = 0;
                        }
                        if (shadowRange[ixc].end) {
                            var convertedDate = DateUtils.convertLocalDateToServer(
                                TimeseriesUtils.parseTsDate(
                                    TimeseriesUtils.convertDateToTsDate(shadowRange[ixc].end, dateFrequency, dateFormat), dateFrequency
                                )
                            );
                            sr.end = lineData[0].findIndex(function (d) {
                                return d.date == convertedDate;
                            });
                        }
                        else {
                            if (shadowRange[ixc].start){
                                sr.end = lineData[0].length - 1;
                            }
                            else{
                                sr.end = 0;
                            }
                        }
                        for (var styleProperty in defaultShadowStyle) {
                            if (defaultShadowStyle.hasOwnProperty(styleProperty) && !shadowRange[ixc].hasOwnProperty(styleProperty)) {
                                sr[styleProperty] = defaultShadowStyle[styleProperty];
                            }
                        }
                        // the shading lies over the lines
                        chartObject.xAxis.shading.push({from: sr.start, to: sr.end, color: sr.color, opacity: sr.opacity, onTop: true});
                    }
                //fill in series of chartObject with the lines' data
                var minValue = Number.MAX_VALUE;
                var maxValue = Number.MIN_VALUE;
                for (ix = 0; ix < lineData.length; ix++) {
                    if (angular.isDefined(lineData[ix])) {
                        //convert dates to formatted date strings
                        for (var jx = 0; jx < lineData[ix].length; jx++) {
                            var yNum = lineData[ix][jx].value;
                            minValue = Math.min(minValue, yNum);
                            maxValue = Math.max(maxValue, yNum);
                            lineData[ix][jx].dateFormatted = TimeseriesUtils.convertDateToTsDate(lineData[ix][jx].date, dateFrequency, dateFormat);
                        }
                        //use default line style if number of lines is higher the number of predefined lines in config
                        if (lineStyles.length < ix + 1) {
                            lineStyles.push(defaultLineStyles.new);
                        }
                        //add series to the chart structure
                        chartObject.series.push({
                            kind: 'line',
                            color: lineStyles[ix].color,//todo -> label: <add some legend string>,
                            lineWidth: lineStyles[ix].width,
                            marker: {show: lineStyles[ix].markerSize > 0, size: lineStyles[ix].markerSize},
                            dash: lineStyles[ix].dashSetting,
                            points: lineData[ix].map(function (d) {
                                return {x: d.dateFormatted, y: d.value};
                            })
                        });
                    }
                }
                // adjust Y-axis range to be tight
                var delta = maxValue - minValue;
                if (lineData.length > 0) {
                    chartObject.yAxis.min = minValue - 0.1 * delta;
                    chartObject.yAxis.max = maxValue + 0.1 * delta;
                }
                // console.log(chartObject);
                //generate the chart from prepared object
                OgrChart.render(element, angular.copy(chartObject));
            }
        }
    }

})();
